import { omit } from 'lodash';
import { BillingModelBase } from './BillingModelBase';
import { BlobModel } from './BlobModel';
import { BillingDetailModel } from './BillingDetailModel';
export class BillingModel extends BillingModelBase {
    constructor(payload) {
        super();
        const basicParams = omit(payload, 'depositSlips');
        Object.assign(this, basicParams);
        this.depositSlips = payload.depositSlips.map((blob) => {
            return new BlobModel(blob);
        });
        this.details = payload.details.map((detail) => {
            return new BillingDetailModel(detail);
        });
    }
    get accumulatedConvenienceFee() {
        let sum = 0;
        this.details.forEach((detail) => {
            sum += detail.convenienceFee;
        });
        return sum;
    }
}
